export const PROJECTION_ACK_SCHEMA = 'sportsnew-trusted-ack/v1';
export const PROJECTION_REVISION_KIND = 'room-projection-sequence/v1';
export const opaqueProjectionId = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
const count = value => Number.isSafeInteger(value) && value > 0 && value <= 999999999999;
const score = value => (typeof value === 'string' || typeof value === 'number')
  && /^\d{1,4}$/.test(String(value));
export const sameProjectionOwner = (a, b) => !!a && !!b
  && ['socket', 'session', 'generation', 'mode', 'scope', 'filter', 'room']
    .every(key => a[key] === b[key]);

export function validProjectionApproval(reply, owner) {
  const v = reply?.observer;
  return reply?.status === true && reply.trusted === true && reply.ackSchema === PROJECTION_ACK_SCHEMA
    && Number.isSafeInteger(reply.serverNow) && reply.serverNow > 0
    && reply.revisionKind === PROJECTION_REVISION_KIND && v?.publicRoom === owner.room
    && ['session', 'room', 'generation', 'build'].every(key => opaqueProjectionId(v[key]));
}

/** Only the finite, explicitly sampled live-list score surface is represented here. */
export function projectionTarget(envelope, approval) {
  const metadata = envelope?.trustedAck;
  if (!metadata || metadata.schema !== PROJECTION_ACK_SCHEMA
      || metadata.revisionKind !== PROJECTION_REVISION_KIND || !approval
      || envelope?.patch?.room !== approval.publicRoom || !count(envelope.sequence)
      || !Array.isArray(metadata.targets) || metadata.targets.length < 1 || metadata.targets.length > 4) return null;
  const view = metadata.projection;
  if (!view || !count(view.fixtureId) || !score(view.home) || !score(view.away)) return null;
  const targets = metadata.targets.filter(target => target?.session === approval.session);
  if (targets.length !== 1) return null;
  const target = targets[0];
  if (!['envelope', 'room', 'session', 'generation', 'build', 'nonce'].every(key => opaqueProjectionId(target[key]))
      || !['room', 'session', 'generation', 'build'].every(key => target[key] === approval[key])
      || target.sequence !== envelope.sequence || target.revision !== envelope.sequence
      || !Number.isSafeInteger(target.deadline) || target.deadline <= 0) return null;
  return Object.freeze({ envelope: target.envelope, room: target.room, nonce: target.nonce,
    sequence: target.sequence, revision: target.revision, deadline: target.deadline, fixtureId: String(view.fixtureId),
    text: `${view.home} : ${view.away}` });
}

export const projectionReceipt = (target, stage) => ({
  envelope: target.envelope, room: target.room, sequence: target.sequence,
  revision: target.revision, nonce: target.nonce, stage,
});

/** Categorical diagnostics only; never expose arbitrary server payloads in the DOM. */
export function projectionNegotiationState(reply, approved) {
  if (approved) return 'approved';
  if (reply === null) return 'timeout';
  const known = ['busy_or_closed', 'retiring', 'not_authorized_or_joined', 'unavailable_or_invalid',
    'socket_rate_limit', 'room_capacity', 'retire_previous_generation_first', 'cohort_closed'];
  return typeof reply?.reason === 'string' && known.includes(reply.reason) ? reply.reason : 'unsupported';
}
